import CRUD from '../masterData/genericCRUD'

const route = 'agronomy/adjustment_events'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function adjustmentEvents(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route)
	}
}
